var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMotorbike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.968,
    height: 34.5,
    viewBox: "0 0 39.968 34.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "motorbike",
    d: "M31.871,18.59,29.537,9.274a4.7,4.7,0,0,0,1.687.31H34.3a1.721,1.721,0,0,0,1.721-1.721V1.721A1.721,1.721,0,0,0,34.3,0H31.224a4.82,4.82,0,0,0-4.468,3.071H20.4a1.721,1.721,0,0,0,0,3.443h3.5V17.626a3.071,3.071,0,0,1-3.064,3.064H19.32V13.323a1.033,1.033,0,0,0-1.033-1.033H14.156V2.066A1.714,1.714,0,0,0,12.435.344H7.181A7.188,7.188,0,0,0,0,7.491v5.832a1.721,1.721,0,0,0,1.721,1.721H4.909A11.746,11.746,0,0,0,.689,24.057v3.388a1.033,1.033,0,0,0,1.033,1.033H4.475a.757.757,0,0,0,0,.124,5.7,5.7,0,1,0,11.395,0v-.124H26.852a.606.606,0,0,0,0,.11,5.7,5.7,0,1,0,11.395,0,.606.606,0,0,0,0-.11h.689a1.033,1.033,0,0,0,1.033-1.033,8.889,8.889,0,0,0-8.1-8.854ZM31.224,3.443H32.6v2.7H31.224a1.377,1.377,0,1,1,0-2.7ZM3.443,7.491A3.746,3.746,0,0,1,7.181,3.752h3.553V11.6H3.443ZM12.428,28.6a2.258,2.258,0,1,1-4.51,0,.757.757,0,0,0,0-.124h4.537A.758.758,0,0,0,12.428,28.6Zm22.384,0a2.258,2.258,0,1,1-4.51,0,.605.605,0,0,0,0-.11h4.537A.606.606,0,0,0,34.811,28.6Z",
    transform: "translate(0 0)",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMotorbike);
export default __webpack_public_path__ + "static/media/icon-motorbike.2d9e078c8e0bb19a8bc3fba24ddb797a.svg";
export { ForwardRef as ReactComponent };